import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link } from 'react-router-dom';

import { Header, Footer, HeaderBox, PSArticle } from '../../components/imports'

import { APP_NAME } from '../../constants/general'
import PlantSitting from '../../class/PlantSitting';

function PlantSittingPage() {

    const navigate = useNavigate()

    const [annonces, setAnnonces] = useState(false)

    const [loading, setLoading] = useState(false)

    const [limit, setLimit] = useState(2)

    const [filtreCategorie, setFiltreCategorie] = useState(false)
    const [filtreNbr, setFiltreNbr] = useState(false)
    // const [filtrePass, setFiltrePass] = useState(false)
    const [filtrePrixMin, setFiltrePrixMin] = useState(false)
    const [filtrePrixMax, setFiltrePrixMax] = useState(false)
    const [filtreQuery, setFiltreQuery] = useState(false)

    const getAnnonces = async (option = false, load = true) => {

        if (load) setAnnonces(false)

        if (!option) {
            setFiltreCategorie(false)
            setFiltreNbr(false)
            // setFiltrePass(false)
            setFiltrePrixMin(false)
            setFiltrePrixMax(false)
            setFiltreQuery(false)
        }

        let results = await PlantSitting.post('annonces', {option:option})

        setLoading(false)

        if (results.success) {

            setAnnonces(results.data)

        } else {

            setAnnonces("Aucune annonce !")


        }

    }

    const changeFilter = (type, val) => {

        // console.log(type, val)

        let categorie = filtreCategorie
        let nbr = filtreNbr
        // let pass = filtrePass
        let p_min = filtrePrixMin
        let p_max = filtrePrixMax
        let query = filtreQuery

        if (type == 'categorie') {
            categorie = val
            setFiltreCategorie(val)
        }

        if (type == 'nbr') {
            nbr = val
            setFiltreNbr(val)
        }

        // if (type == 'pass') {
        //     pass = val
        //     setFiltrePass(val)
        // }

        if (type == 'min') {
            p_min = val
            setFiltrePrixMin(val)
        }

        if (type == 'max') {
            p_max = val
            setFiltrePrixMax(val)
        }

        if (type == 'query') {
            query = val
            setFiltreQuery(val)
        }

        getAnnonces({ 'categorie': categorie, 'nbr': nbr, 'min': p_min, 'max': p_max, 'query': query })

    }

    const debounce = (func, timeout = 400) => {
        let timer;
        return (...args) => {
            clearTimeout(timer)
            timer = setTimeout(() => { func.apply(this, args); }, timeout)
        }
    }

    const processChange = debounce((e) => changeFilter('query', e.target.value))

    const voirPlus = () => {

        let categorie = filtreCategorie
        let nbr = filtreNbr
        // let pass = filtrePass
        let p_min = filtrePrixMin
        let p_max = filtrePrixMax
        let query = filtreQuery

        setLoading(true)

        getAnnonces({'categorie': categorie, 'nbr': nbr, 'min': p_min, 'max': p_max, 'query': query, limit: limit }, false)

        setLimit(limit + 1)

    }

    useEffect(() => {

        getAnnonces()

        document.title = "Plant Sitting - " + APP_NAME

        document.body.classList.remove('mn')

    }, [])

    return (

        <div>

            <Header />

            <div className="plantsitting">

                <HeaderBox />

                <div className="c-0 pos-r content">

                    <div className="flex ai-center mb60 m_p10 m_mb_20 m_mt_30">

                        <p className='fz11'>Tu aimes les plantes ? Et si tu en prenais soin pendant que d’autres partent en vacances ?</p>

                        <Link to={'/plant-sitting/proposer'} className='btn bg3 cl1 m_mt_10'>Je propose un plant sitting</Link>

                    </div>

                    <div className="flex mb20 m_p10 m_mb_0">
                        <form method='POST' className='gla-form pos-r head_form' onSubmit={e => e.preventDefault()}>
                            <span className='icon'>d</span>
                            <input type='search' name='query' placeholder='Rechercher ville ...' autoComplete="off" className='search_input' onChange={e => processChange(e)} />
                        </form>
                    </div>

                    <div className="flex mt10 m_mt_0">

                        <div className="col-2 aside m_p10 m_mb_40">

                            {

                                (filtreCategorie || filtreNbr || filtrePrixMin || filtrePrixMax)

                                &&

                                <>
                                    <span className='cl4 mr5 icon' onClick={e => navigate(0)}>w</span>
                                    <span classname="fz08">Supprimer les filtres</span>
                                </>

                            }

                            <span className='cl4 t'>Nombre de plantes</span>

                            <div>
                                <input type="radio" name='nbr' id="s1" onChange={e => changeFilter('nbr', '30')} className='mr10' />
                                <label htmlFor="s1"> jusqu'à 30 plantes</label>
                            </div>

                            <div>
                                <input type="radio" name='nbr' id="s2" onChange={e => changeFilter('nbr', "sup30")} className='mr10' />
                                <label htmlFor="s2"> plus de 30 plantes</label>
                            </div>

                            <span className='cl4 t'>Afficher</span>

                            <div>
                                <input type="radio" name='cat' id="g" onChange={e => changeFilter('categorie', 1)} className='mr10' />
                                <label htmlFor="g">Gardiennage</label>
                            </div>

                            <div>
                                <input type="radio" name='cat' id="a" onChange={e => changeFilter('categorie', 2)} className='mr10' />
                                <label htmlFor="a">Arrosage</label>
                            </div>

                            <div className='mb20'>
                                <input type="radio" name='cat' id="j" onChange={e => changeFilter('categorie', 3)} className='mr10' />
                                <label htmlFor="j">Jardinage</label>
                            </div>

                            {/* <div>
                                <input type="radio" id="s3" name='passage' onChange={e => changeFilter('pass', 1)}  className='mr10' />
                                <label htmlFor="s3">1 Passage / semaine</label>
                            </div>

                            <div>
                                <input type="radio" id="s4" name='passage' onChange={e => changeFilter('pass', 2)}  className='mr10' />
                                <label htmlFor="s4">2 passages / semaine</label>
                            </div> */}

                            <span className='cl4 t'>Prix</span>

                            <div className="grid2 cat_filter m_flex">

                                <div>
                                    <label>Min</label>
                                    <input type="number" placeholder='€' className='prix_min col-10 brc4' value={filtrePrixMin} onChange={e => changeFilter('min', e.target.value)} />
                                </div>

                                <div>
                                    <label>Max</label>
                                    <input type="number" placeholder='€' className='prix_max col-10 brc4' value={filtrePrixMax} onChange={e => changeFilter('max', e.target.value)} />
                                </div>

                            </div>


                        </div>

                        <div className="col-78 m_mb_40">

                            {

                                annonces

                                    ?

                                    typeof annonces == 'object'

                                        ?

                                        <>

                                            <div className="services grid4">

                                                {annonces.map(element => <PSArticle data={element} key={element.idA} />)}

                                            </div>

                                            {loading && <div className='flex jc-center mt50 mb50'><div className="lds-dual-ring col"></div></div>}

                                            {

                                                annonces.length % 12 == 0

                                                &&

                                                <div className='flex jc-center mt30 m_flex m_p10 m_mb_10'>
                                                    <span className='btn bg4 cl1' onClick={voirPlus}>Voir plus</span>
                                                </div>

                                            }

                                        </>

                                        :

                                        <p>Aucune annonce !</p>

                                    :

                                    <div className='flex jc-center mt50 mb50'>
                                        <div className="lds-dual-ring col"></div>
                                    </div>

                            }

                        </div>

                    </div>

                </div>

                <Footer />

            </div>

        </div>

    )

}

export default PlantSittingPage